import { render } from "./CarrosRelatorio.vue?vue&type=template&id=a3a6714a&scoped=true"
import script from "./CarrosRelatorio.vue?vue&type=script&lang=js"
export * from "./CarrosRelatorio.vue?vue&type=script&lang=js"

import "./CarrosRelatorio.vue?vue&type=style&index=0&id=a3a6714a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3a6714a"]])

export default __exports__